(ns frontend.view.entity-viewers.events.task-editor
  (:require
   [frontend.state.current-session :as session]
   [common.localization :as loc]
   [clojure.string :as string]
   [frontend.actions.task :as task]
   [frontend.ux-overhaul.page-components.navigation.events :as navigation-events]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [frontend.db :as app-db]
   [common.schema.registry :as registry]
   [frontend.zap-time :as zap-time]
   [common.util :as cu]))

(defn empty-editor-value?
  [v]
  (let [value (->> v
                   (str)
                   (string/trim))]
    (or (empty? value)
        (= value "<p><br></p>"))))

(defn task-editor
  [{:keys [state entity-id externally-passed-entity viewed-entity-id show-expanded? modal? on-reset! on-success-callback! custom-delete-button]}]
  (let [current-account-id @session/account-id
        account-id (or (when (get @app-db/active-user-account-roles current-account-id)
                         current-account-id)
                       (->> @session/all-accounts
                            (filter (fn [a]
                                      (get @app-db/active-user-account-roles (:db/id a))))
                            (first)
                            :db/id))
        schema (let [full-schema (registry/get-schema @session/tenant-schema :entity.type/task)]
                 (dissoc full-schema
                         :task/type
                         :task/source
                         (when (or (not (session/fundraising?))
                                   (session/no-known-entities? :entity.type/fund-commitment @session/all-fund-commitments))
                           :common/related-entities-fund-commitment)
                         (when (or (not (session/fundraising?))
                                   (session/no-known-entities? :entity.type/fund @session/all-funds))
                           :common/related-entities-fund)
                         (when (or (not (session/fundraising?))
                                   (session/no-known-entities? :entity.type/investor @session/all-investors))
                           :common/related-entities-investor)
                         (when (or (not (session/fundraising?))
                                   (session/no-known-entities? :entity.type/fundraising-opportunity @session/all-fundraising-opportunities))
                           :common/related-entities-fundraising-opportunities)
                         (when (or (not (session/sales-pipelines?))
                                   (session/no-known-entities? :entity.type/sales-opportunity @session/all-sales-opportunities))
                           :common/related-entities-sales-opportunities)
                         (when (or (not (session/dealflow?))
                                   (session/no-known-entities? :entity.type/oppo @session/all-oppos))
                           :common/related-entities-oppo)
                         (when (or (not (session/portfolio?))
                                   (session/no-known-entities? :entity.type/holding @session/all-holdings))
                           :common/related-entities-holdings)
                         (when (or (not (session/sales-pipelines?))
                                   (session/no-known-entities? :entity.type/sale-agreement @session/all-sale-agreements))
                           :common/related-entities-sale-agreements)
                         (when-not (session/has-feature-access? :feature/asset-types-real-estate)
                           :common/related-entities-real-estate)
                         (when-not (session/has-feature-access? :feature/fund-management)
                           :common/related-entities-fund)
                         (when-not (session/has-feature-access? :feature/fundraising)
                           :common/related-entities-fundraising-opportunities)
                         (when-not (session/has-feature-access? :feature/fundraising)
                           :common/related-entities-investor)
                         (when-not (session/has-feature-access? :feature/fundraising)
                           :common/related-entities-fund-commitment)))]
    [editor-utils/editor
     {:state                state
      :always-expanded?     show-expanded?
      :full-width?          true
      :modal?               modal?
      :activity-entity-id   entity-id
      :externally-passed-entity externally-passed-entity
      :viewed-entity-id     viewed-entity-id
      :activity-entity-type :task
      :wysiwyg-attribute    :task/message
      :placeholder          (loc/tr :task-editor-placeholder)
      :init-draft-state!    (fn [update-draft!]
                              (when viewed-entity-id
                                (update-draft! :common/related-entities #{viewed-entity-id}))
                              (when-not (session/is-guest?)
                                (update-draft! :task/assignee account-id))
                              (update-draft! :task/created (zap-time/now)))
      :entity-schema        schema
      :mandatory-field?     #(some #{(:attribute %)} [:task/assignee])
      :on-success-callback! on-success-callback!
      :custom-delete-button custom-delete-button
      :on-reset!            on-reset!
      :on-submit!           (fn [data on-success! on-error!]
                              (task/*create-task->
                               (cu/remove-nil-vals data)
                               (fn [resp]
                                 (navigation-events/refresh-task-badge-counts!)
                                 (on-success! resp)
                                 (when (fn? on-success-callback!)
                                   (on-success-callback! resp)))
                               on-error!))
      :submit-button-text   (loc/tr :logger-view/button-add-task)
      :disabled-button-tooltip-text (fn [entity-atom]
                                      (let [associated-empty? (->> :common/related-entities
                                                                   (get @entity-atom)
                                                                   empty?)
                                            owner (:task/assignee @entity-atom)
                                            message (:task/message @entity-atom)]
                                        (cond (nil? owner)
                                              (loc/tr :task/must-have-owner)
                                              (empty-editor-value? message)
                                              (loc/tr :task/must-have-description)
                                              associated-empty?
                                              (loc/tr :task/must-have-at-least-one-associated))))}]))
